import { render } from "./FooterView.vue?vue&type=template&id=0fa15b76"
import script from "./FooterView.vue?vue&type=script&lang=js"
export * from "./FooterView.vue?vue&type=script&lang=js"

import "./FooterView.vue?vue&type=style&index=0&id=0fa15b76&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__